import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TimeResolver {
  constructor(private translate: TranslateService) {}

  getTimeSpanToDays(days: number): Date {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let calculatePreviousDate = new Date(today);
    calculatePreviousDate.setDate(calculatePreviousDate.getDate() + days);
    return calculatePreviousDate;
  }

  getCurrentDate(): Date {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  getTimeSpanFromDays(days: number): Date {
    const today = new Date();
    let calculatePreviousDate = new Date(today);
    calculatePreviousDate.setDate(calculatePreviousDate.getDate() - days);
    return calculatePreviousDate;
  }

  getYesterdayDate(): Date {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let calculatePreviousDate = new Date(today);
    calculatePreviousDate.setDate(calculatePreviousDate.getDate() - 1);
    return calculatePreviousDate;
  }

  getPreviousSelectedDate(selectedDate): Date {
    const today = new Date(selectedDate);
    today.setHours(0, 0, 0, 0);
    const calculatePreviousDate = new Date(today);
    calculatePreviousDate.setDate(calculatePreviousDate.getDate() - 1);
    return calculatePreviousDate;
  }

  formatRelativeTime(timestamp: number): string {
    const now = Date.now();
    const diffInMs = now - timestamp;

    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    const justNowLabel = this.translate.instant('Just now');

    if (years > 0) {
      return this.translate.instant(years > 1 ? 'years_ago' : 'year_ago', {
        count: years,
      });
    } else if (months > 0) {
      return this.translate.instant(months > 1 ? 'months_ago' : 'month_ago', {
        count: months,
      });
    } else if (weeks > 0) {
      return this.translate.instant(weeks > 1 ? 'weeks_ago' : 'week_ago', {
        count: weeks,
      });
    } else if (days > 0) {
      return this.translate.instant(days > 1 ? 'days_ago' : 'day_ago', {
        count: days,
      });
    } else if (hours > 0) {
      return this.translate.instant(hours > 1 ? 'hours_ago' : 'hour_ago', {
        count: hours,
      });
    } else if (minutes > 0) {
      return this.translate.instant(
        minutes > 1 ? 'minutes_ago' : 'minute_ago',
        { count: minutes }
      );
    } else {
      return justNowLabel;
    }
  }
}
